<template>
    <div class="user-info__settings-menu">
        <div v-if="!isAdmin()" class="user-info__settings-section">
            <router-link :to="{ name: 'Profile' }" class="user-info__settings-element">
                <img v-svg-inline src="@/assets/icons/profile.svg" />
                <span>Мой профиль</span>
            </router-link>
        </div>

        <div v-if="!isAdmin()" class="user-info__settings-section">
            <div class="user-info__settings-element" @click="emit('change-dealer')">
                <img v-svg-inline src="@/assets/icons/lucide_briefcase-business.svg" />

                <span>Сменить дилера</span>

                <div class="user-info__settings-element-after user-info__settings-element-go-arrow">
                    <img v-svg-inline src="@/assets/icons/arrow-right.svg" />
                </div>
            </div>
        </div>

        <div class="user-info__settings-element" @click="logout">
            <img v-svg-inline src="@/assets/icons/logout.svg" />
            <span>Выйти</span>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { injectStrict } from '@/injection/injectStrict.ts';
    import { AuthKey } from '@/injection/keys.ts';

    import usePermission from '@/repositories/auth/usePermission.ts';

    const emit = defineEmits<{
        (e: 'change-dealer'): void,
    }>();

    const $Auth = injectStrict(AuthKey);

    const { isAdmin } = usePermission();

    const logout = (): void => {
        $Auth.logout();
    };
</script>
